import { BewerberStatus } from '../../../types/bewerber';

// SVG Icon Components
export const EnvelopeIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

export const CheckIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

export const QuestionIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

export const WarningIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
  </svg>
);

export const CalendarIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
  </svg>
);

export const DocumentIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

export const RocketIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
  </svg>
);

export const RefreshIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  </svg>
);

export const CheckCircleIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

export const PencilIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
  </svg>
);

export const ClipboardIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
  </svg>
);

export const XCircleIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

export const BookmarkIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
  </svg>
);

export const TrashIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

// Heroicons outline "arrow-right-on-rectangle" — leaving.
export const ExitIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l3 3m0 0l-3 3m3-3H2.25" />
  </svg>
);

export type ModalType = 'zurKlaerung' | 'einladen' | 'kennenlernen' | 'arbeitsvertrag' | 'absage' | 'reactivate' | 'nichtGeeignet' | 'hardDelete' | 'anfordern';

// Configuration for status-specific actions
export interface ActionConfig {
  key: string;
  label: string;
  loadingLabel: string;
  color: string;
  hoverColor: string;
  action: 'email' | 'statusChange' | 'modal' | 'conditionalModal' | 'apiCall' | 'navigate';
  newStatus?: BewerberStatus;
  templateName?: string;
  modalType?: ModalType;
  apiAction?: 'markReviewed' | 'mark' | 'unmark';
  navigateTo?: string; // For navigation actions
  icon: React.FC;
  tooltip: string;
  group: 'primary' | 'secondary' | 'danger'; // For dropdown grouping
  disabled?: boolean; // For temporarily disabled actions
  confirmAfterEmail?: boolean; // For email actions that should also mark bewerber as confirmed
}

/**
 * Opens the guided interview questionnaire. Shared across every status the tool is
 * available in (VORSTELLUNG onwards) so the label and target cannot drift apart.
 */
const INTERVIEW_TOOL_ACTION: ActionConfig = {
  key: 'interview-tool',
  label: 'Interview Tool',
  loadingLabel: 'Wird geöffnet...',
  color: 'border-indigo-300 text-indigo-700 bg-indigo-50',
  hoverColor: 'hover:bg-indigo-100',
  action: 'navigate',
  navigateTo: '/bewerber/:id/vorstellungsgespraech',
  icon: ClipboardIcon,
  tooltip: 'Öffnet den Vorstellungsgespräch-Fragebogen',
  group: 'primary',
};

/**
 * Start the wind-up. Offered from ONBOARDING (a hire that is being unwound) and
 * from GEWONNEN (someone leaving a running placement) — the two statuses where
 * there is an employment to end.
 */
const OFFBOARDING_ACTION: ActionConfig = {
  key: 'offboarding',
  label: 'Offboarding starten',
  loadingLabel: 'Wird gestartet...',
  color: 'border-rose-300 text-rose-700 bg-rose-50',
  hoverColor: 'hover:bg-rose-100',
  action: 'statusChange',
  newStatus: BewerberStatus.OFFBOARDING,
  icon: ExitIcon,
  tooltip: 'Startet die Abwicklung des Arbeitsverhältnisses',
  group: 'primary',
};

export const STATUS_ACTIONS: Partial<Record<BewerberStatus, ActionConfig[]>> = {
  [BewerberStatus.NEU]: [
    {
      key: 'confirm',
      label: 'Bestätigen',
      loadingLabel: 'Wird gesendet...',
      color: 'border-blue-300 text-blue-700 bg-blue-50',
      hoverColor: 'hover:bg-blue-100',
      action: 'email',
      templateName: 'bewerber-confirmation',
      confirmAfterEmail: true,
      icon: EnvelopeIcon,
      tooltip: 'Sendet Bestätigungsmail an den Bewerber',
      group: 'primary',
    },
    {
      key: 'anfordern',
      label: 'Anfordern',
      loadingLabel: 'Wird geöffnet...',
      color: 'border-gray-300 text-gray-700 bg-gray-50',
      hoverColor: 'hover:bg-gray-100',
      action: 'modal',
      modalType: 'anfordern',
      icon: WarningIcon,
      tooltip: 'Unterlagen anfordern - E-Mail wird gesendet',
      group: 'primary',
    },
    {
      key: 'zur-klaerung',
      label: 'Klärung anfordern',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-yellow-300 text-yellow-700 bg-yellow-50',
      hoverColor: 'hover:bg-yellow-100',
      action: 'modal',
      modalType: 'zurKlaerung',
      icon: QuestionIcon,
      tooltip: 'Weist Bewerber einem Mitarbeiter zur Klärung zu',
      group: 'primary',
    },
    {
      key: 'geeignet',
      label: 'Freigeben',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-cyan-300 text-cyan-700 bg-cyan-50',
      hoverColor: 'hover:bg-cyan-100',
      action: 'statusChange',
      newStatus: BewerberStatus.GEEIGNET,
      icon: CheckIcon,
      tooltip: 'Markiert den Bewerber als geeignet',
      group: 'primary',
    },
    {
      key: 'nicht-geeignet',
      label: 'Nicht geeignet',
      loadingLabel: 'Wird markiert...',
      color: 'border-amber-300 text-amber-700 bg-amber-50',
      hoverColor: 'hover:bg-amber-100',
      action: 'modal',
      modalType: 'nichtGeeignet',
      icon: WarningIcon,
      tooltip: 'Markiert den Bewerber als nicht geeignet',
      group: 'primary',
    },
  ],

  [BewerberStatus.KEINE_ANLAGEN]: [
    {
      key: 'zur-klaerung',
      label: 'Klärung anfordern',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-yellow-300 text-yellow-700 bg-yellow-50',
      hoverColor: 'hover:bg-yellow-100',
      action: 'modal',
      modalType: 'zurKlaerung',
      icon: QuestionIcon,
      tooltip: 'Weist Bewerber einem Mitarbeiter zur Klärung zu',
      group: 'primary',
    },
    {
      key: 'geeignet',
      label: 'Freigeben',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-cyan-300 text-cyan-700 bg-cyan-50',
      hoverColor: 'hover:bg-cyan-100',
      action: 'statusChange',
      newStatus: BewerberStatus.GEEIGNET,
      icon: CheckIcon,
      tooltip: 'Markiert den Bewerber als geeignet',
      group: 'primary',
    },
  ],

  [BewerberStatus.ZU_KLAEREN]: [
    {
      key: 'geeignet',
      label: 'Freigeben',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-cyan-300 text-cyan-700 bg-cyan-50',
      hoverColor: 'hover:bg-cyan-100',
      action: 'statusChange',
      newStatus: BewerberStatus.GEEIGNET,
      icon: CheckIcon,
      tooltip: 'Markiert den Bewerber als geeignet',
      group: 'primary',
    },
  ],

  [BewerberStatus.NICHT_GEEIGNET]: [
    {
      key: 'geeignet',
      label: 'Freigeben',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-cyan-300 text-cyan-700 bg-cyan-50',
      hoverColor: 'hover:bg-cyan-100',
      action: 'statusChange',
      newStatus: BewerberStatus.GEEIGNET,
      icon: CheckIcon,
      tooltip: 'Markiert den Bewerber als geeignet',
      group: 'primary',
    },
  ],

  [BewerberStatus.GEEIGNET]: [
    {
      key: 'einladen',
      label: 'Einladung senden',
      loadingLabel: 'Wird gesendet...',
      color: 'border-purple-300 text-purple-700 bg-purple-50',
      hoverColor: 'hover:bg-purple-100',
      action: 'conditionalModal',
      templateName: 'bewerber-einladen',
      newStatus: BewerberStatus.EINGELADEN,
      modalType: 'einladen',
      icon: EnvelopeIcon,
      tooltip: 'Sendet Einladungsmail an den Bewerber',
      group: 'primary',
    },
    {
      key: 'kennenlernen',
      label: 'Kennenlernen planen',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-green-300 text-green-700 bg-green-50',
      hoverColor: 'hover:bg-green-100',
      action: 'modal',
      modalType: 'kennenlernen',
      icon: CalendarIcon,
      tooltip: 'Bald verfügbar',
      group: 'primary',
      disabled: true,
    },
    {
      key: 'im-pool',
      label: 'In Pool aufnehmen',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-green-300 text-green-700 bg-green-50',
      hoverColor: 'hover:bg-green-100',
      action: 'statusChange',
      newStatus: BewerberStatus.IM_POOL,
      icon: ArrowRightIcon,
      tooltip: 'Nimmt den Bewerber in den Pool auf',
      group: 'primary',
    },
  ],

  [BewerberStatus.VORSTELLUNG]: [
    // The interview happens now, so this leads.
    INTERVIEW_TOOL_ACTION,
    {
      key: 'einladen',
      label: 'Einladung senden',
      loadingLabel: 'Wird gesendet...',
      color: 'border-purple-300 text-purple-700 bg-purple-50',
      hoverColor: 'hover:bg-purple-100',
      action: 'conditionalModal',
      templateName: 'bewerber-einladen',
      newStatus: BewerberStatus.EINGELADEN,
      modalType: 'einladen',
      icon: EnvelopeIcon,
      tooltip: 'Sendet Einladungsmail an den Bewerber',
      group: 'primary',
    },
    {
      key: 'im-pool',
      label: 'In Pool aufnehmen',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-green-300 text-green-700 bg-green-50',
      hoverColor: 'hover:bg-green-100',
      action: 'statusChange',
      newStatus: BewerberStatus.IM_POOL,
      icon: ArrowRightIcon,
      tooltip: 'Nimmt den Bewerber in den Pool auf',
      group: 'primary',
    },
    {
      key: 'nicht-geeignet',
      label: 'Nicht geeignet',
      loadingLabel: 'Wird markiert...',
      color: 'border-amber-300 text-amber-700 bg-amber-50',
      hoverColor: 'hover:bg-amber-100',
      action: 'modal',
      modalType: 'nichtGeeignet',
      icon: WarningIcon,
      tooltip: 'Markiert den Bewerber als nicht geeignet',
      group: 'primary',
    },
  ],

  [BewerberStatus.EINGELADEN]: [
    {
      key: 'einladen',
      label: 'Erneut einladen',
      loadingLabel: 'Wird gesendet...',
      color: 'border-purple-300 text-purple-700 bg-purple-50',
      hoverColor: 'hover:bg-purple-100',
      action: 'conditionalModal',
      templateName: 'bewerber-einladen',
      newStatus: BewerberStatus.EINGELADEN,
      modalType: 'einladen',
      icon: EnvelopeIcon,
      tooltip: 'Sendet eine weitere Einladung',
      group: 'primary',
    },
  ],

  [BewerberStatus.IM_POOL]: [
    {
      key: 'kennenlerngespraech',
      label: 'Kennenlerngespräch',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-lime-300 text-lime-700 bg-lime-50',
      hoverColor: 'hover:bg-lime-100',
      action: 'statusChange',
      newStatus: BewerberStatus.KENNENLERNGESPRAECH,
      icon: CalendarIcon,
      tooltip: 'Bewerber ins Kennenlerngespräch übernehmen',
      group: 'primary',
    },
    {
      key: 'kennenlernen',
      label: 'Kennenlernen planen',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-green-300 text-green-700 bg-green-50',
      hoverColor: 'hover:bg-green-100',
      action: 'modal',
      modalType: 'kennenlernen',
      icon: CalendarIcon,
      tooltip: 'Bald verfügbar',
      group: 'primary',
      disabled: true,
    },
    {
      key: 'onboarding',
      label: 'Einstellen starten',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-teal-300 text-teal-700 bg-teal-50',
      hoverColor: 'hover:bg-teal-100',
      action: 'statusChange',
      newStatus: BewerberStatus.ONBOARDING,
      icon: RocketIcon,
      tooltip: 'Startet die Einstellung',
      group: 'primary',
    },
    INTERVIEW_TOOL_ACTION,
  ],

  [BewerberStatus.KENNENLERNGESPRAECH]: [
    {
      key: 'onboarding',
      label: 'Einstellen starten',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-teal-300 text-teal-700 bg-teal-50',
      hoverColor: 'hover:bg-teal-100',
      action: 'statusChange',
      newStatus: BewerberStatus.ONBOARDING,
      icon: RocketIcon,
      tooltip: 'Startet die Einstellung',
      group: 'primary',
    },
    INTERVIEW_TOOL_ACTION,
  ],

  [BewerberStatus.ONBOARDING]: [
    {
      key: 'arbeitsvertrag',
      label: 'Vertrag erstellen',
      loadingLabel: 'Wird generiert...',
      color: 'border-teal-300 text-teal-700 bg-teal-50',
      hoverColor: 'hover:bg-teal-100',
      action: 'modal',
      modalType: 'arbeitsvertrag',
      icon: DocumentIcon,
      tooltip: 'Bald verfügbar',
      group: 'primary',
      disabled: true,
    },
    // Sind beide Schritte gehakt, schiebt die Checkliste von selbst nach
    // GEWONNEN. Dieser Knopf ist der Weg mit offenen Schritten: die stehen nicht
    // mehr im Weg, er fragt nur nach (useBewerberActions).
    {
      key: 'einstellen',
      label: 'Als eingestellt markieren',
      loadingLabel: 'Wird verarbeitet...',
      color: 'border-emerald-300 text-emerald-700 bg-emerald-50',
      hoverColor: 'hover:bg-emerald-100',
      action: 'statusChange',
      newStatus: BewerberStatus.GEWONNEN,
      icon: CheckIcon,
      tooltip: 'Schließt die Einstellung ab (fragt nach, wenn Einstellen-Schritte offen sind)',
      group: 'primary',
    },
    {
      key: 'unterlagen',
      label: 'Unterlagen senden',
      loadingLabel: 'Wird gesendet...',
      color: 'border-blue-300 text-blue-700 bg-blue-50',
      hoverColor: 'hover:bg-blue-100',
      action: 'email',
      templateName: 'bewerber-unterlagen',
      icon: EnvelopeIcon,
      tooltip: 'Coming soon',
      group: 'primary',
      disabled: true,
    },
    OFFBOARDING_ACTION,
    INTERVIEW_TOOL_ACTION,
  ],

  [BewerberStatus.GEWONNEN]: [OFFBOARDING_ACTION, INTERVIEW_TOOL_ACTION],

  [BewerberStatus.OFFBOARDING]: [
    {
      key: 'offboardingAbschliessen',
      label: 'Offboarding abschließen',
      loadingLabel: 'Wird abgeschlossen...',
      color: 'border-red-300 text-red-700 bg-red-50',
      hoverColor: 'hover:bg-red-100',
      action: 'statusChange',
      newStatus: BewerberStatus.VERLOREN,
      icon: CheckIcon,
      // Not an Absage: nobody was rejected, the employment ended. Hence a plain
      // status change rather than the AbsageModal every other route to VERLOREN takes.
      tooltip: 'Beendet die Abwicklung und setzt den Bewerber auf Verloren',
      group: 'primary',
    },
    INTERVIEW_TOOL_ACTION,
  ],

  [BewerberStatus.VERLOREN]: [
    {
      key: 'reactivate',
      label: 'Reaktivieren',
      loadingLabel: 'Wird reaktiviert...',
      color: 'border-green-300 text-green-700 bg-green-50',
      hoverColor: 'hover:bg-green-100',
      action: 'modal',
      modalType: 'reactivate',
      icon: RefreshIcon,
      tooltip: 'Reaktiviert den Bewerber und nimmt ihn wieder in den Prozess auf',
      group: 'primary',
    },
  ],
};

// Secondary actions available for all statuses (navigation)
export const SECONDARY_ACTIONS: ActionConfig[] = [
  {
    key: 'edit',
    label: 'Bearbeiten',
    loadingLabel: 'Bearbeiten',
    color: 'text-gray-700',
    hoverColor: 'hover:bg-gray-100',
    action: 'navigate',
    navigateTo: '/bewerber/:id/bearbeiten',
    icon: PencilIcon,
    tooltip: 'Bewerber bearbeiten',
    group: 'secondary',
  },
];

// Danger actions
export const DANGER_ACTIONS: ActionConfig[] = [
  {
    key: 'absage',
    label: 'Absagen',
    loadingLabel: 'Wird abgesagt...',
    color: 'text-red-700',
    hoverColor: 'hover:bg-red-50',
    action: 'modal',
    modalType: 'absage',
    icon: XCircleIcon,
    tooltip: 'Bewerber absagen',
    group: 'danger',
  },
];

// Dynamic action for hasSecondApplication
export const MARK_REVIEWED_ACTION: ActionConfig = {
  key: 'mark-reviewed',
  label: 'Erneut geprüft',
  loadingLabel: 'Wird markiert...',
  color: 'border-amber-300 text-amber-700 bg-amber-50',
  hoverColor: 'hover:bg-amber-100',
  action: 'apiCall',
  apiAction: 'markReviewed',
  icon: CheckCircleIcon,
  tooltip: 'Markiert die zweite Bewerbung als geprüft und entfernt den Marker',
  group: 'danger',
};

// Context menu action for "Nicht geeignet" (used on all statuses except GEWONNEN, VERLOREN, NICHT_GEEIGNET)
export const NICHT_GEEIGNET_ACTION: ActionConfig = {
  key: 'nicht-geeignet',
  label: 'Nicht geeignet',
  loadingLabel: 'Wird markiert...',
  color: 'text-amber-700',
  hoverColor: 'hover:bg-amber-50',
  action: 'modal',
  modalType: 'nichtGeeignet',
  icon: WarningIcon,
  tooltip: 'Markiert den Bewerber als nicht geeignet',
  group: 'danger',
};

// Dynamic actions for mark/unmark attention
export const MARK_ACTION: ActionConfig = {
  key: 'mark',
  label: 'Markieren',
  loadingLabel: 'Wird markiert...',
  color: 'text-amber-700',
  hoverColor: 'hover:bg-amber-50',
  action: 'apiCall',
  apiAction: 'mark',
  icon: BookmarkIcon,
  tooltip: 'Bewerber zur Beachtung markieren',
  group: 'secondary',
};

export const UNMARK_ACTION: ActionConfig = {
  key: 'unmark',
  label: 'Markierung entfernen',
  loadingLabel: 'Wird entfernt...',
  color: 'text-gray-700',
  hoverColor: 'hover:bg-gray-100',
  action: 'apiCall',
  apiAction: 'unmark',
  icon: BookmarkIcon,
  tooltip: 'Markierung entfernen',
  group: 'secondary',
};

// Hard delete action - only for NEU status
export const HARD_DELETE_ACTION: ActionConfig = {
  key: 'hardDelete',
  label: 'Permanent löschen',
  loadingLabel: 'Wird gelöscht...',
  color: 'text-red-700',
  hoverColor: 'hover:bg-red-50',
  action: 'modal',
  modalType: 'hardDelete',
  icon: TrashIcon,
  tooltip: 'Löscht den Bewerber permanent aus dem System',
  group: 'danger',
};
